import React from 'react'

function TrashIcon({
   className = ""
}) {
   return (
      <svg className={className} viewBox="0 0 24 24">
         <path d="M6 7H5v13a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7H6zm10.618-3L15 2H9L7.382 4H3v2h18V4z"></path>
      </svg>
   )
}

export default TrashIcon